import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    issueChangeStep,
    issueMapCenter,
    gmapsGeocoder,
    issueUpdateForm,
    issueStore,
    issueSubmit,
    issueResetForm,
    publicLoadIssuesItem,
    publicDelAttachItem,
    publicDelTempAttachItem,
    getDeviceGeolocation
} from '../actions/issue'
import PublicFormComponent from '../components/PublicForm'
import PublicSimpleFormComponent from '../components/PublicSimpleForm'
import PublicFormSubmittedComponent from '../components/PublicFormSubmitted'
import LoadingComponent from '../components/Loading'
import DeniedComponent from '../components/Denied'
import Permissions from '../models/Permissions'

class PublicForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        this.setState({loading: true})
        this.props.loadOwnItem(this.props.match.params.id)
    }

    componentWillReceiveProps(nextProps) {
        var routeId = nextProps.match.params.id || ''
        var lastRouteId = this.props.match.params.id || ''
        if (routeId !== lastRouteId) {
            this.setState({loading: true})
            this.props.loadOwnItem(routeId)
        } else {
            this.setState({loading: false})
        }
    }

    render() {
        if (this.props.data.submitdate && this.props.complete && !this.props.error) {
            return (
                <PublicFormSubmittedComponent {...this.props} />
            )
        }
        if (this.state.loading) return (<LoadingComponent />)
        if (Permissions.isDenied('issues', 'create')) return <DeniedComponent />
        
        // Render simple form
        if (!this.props.auth.id) {
            return (
                <PublicSimpleFormComponent {...this.props}
                    onStepBackward={this.onStepBackward}
                    onStepForward={this.onStepForward}
                />
            )
        }

        // Render complete form
        return (
            <PublicFormComponent {...this.props}
                onStepBackward={this.onStepBackward}
                onStepForward={this.onStepForward}
            />
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.issueForm)
    nextProps['auth'] = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadOwnItem: (id) => {
            dispatch(publicLoadIssuesItem(id))
        },
        changeStep: (step) => {
            dispatch(issueChangeStep(step))
        },
        changeMapCenter: (center, zoom, getLimits = false) => {
            dispatch(issueMapCenter(center, zoom, getLimits))
        },
        gmapsGeocoder: (address) => {
            dispatch(gmapsGeocoder(address))
        },
        updateForm: (formData) => {
            dispatch(issueUpdateForm(formData))
        },
        storeForm: (formData) => {
            dispatch(issueStore(formData))
        },
        submitForm: (formData) => {
            dispatch(issueSubmit(formData))
        },
        resetForm: () => {
            dispatch(issueResetForm())
        },
        removeAttach: (item) => {
            dispatch(publicDelAttachItem(item))
        },
        removeTempAttach: (item) => {
            dispatch(publicDelTempAttachItem(item))
        },
        getDeviceGeolocation: () => {
            dispatch(getDeviceGeolocation())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicForm)



// WEBPACK FOOTER //
// ./src/containers/PublicForm.js